import { POST_MANUAL_AML_FAILURE, POST_MANUAL_AML_REQUEST, POST_MANUAL_AML_SUCCESS } from '../actions/manual-aml'

export const manualAml = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
    errors: {},
  },
  action
) => {
  switch (action.type) {
    case POST_MANUAL_AML_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case POST_MANUAL_AML_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case POST_MANUAL_AML_FAILURE:
      return {
        ...state,
        errors: action.details,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
